import { forwardRef, InputHTMLAttributes, ReactNode } from 'react'

import classnames from 'classnames'

import InputFeedback from '../inputFeedback'

import '@hotmart/cosmos/dist/form/form.css'
import '@hotmart/cosmos/dist/form/input-custom.css'
import '@hotmart/cosmos/dist/form/input-radio.css'
import './radio.scss'

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  label?: ReactNode,
  errorMessage?: string,
  hint?: string,
  hasError?: boolean
}

const Radio = forwardRef<HTMLInputElement, Props>(
  ({ label, name, hasError, className, errorMessage, hint, id, ...others }, forwardedRef) => (
    <div className="hot-form hot-form--custom hot-form--radio">
      <input
        type="radio"
        className={classnames('hot-form__input', { 'is-invalid': hasError }, className)}
        name={name}
        ref={forwardedRef}
        id={id}
        {...others}/>
      <label className="hot-form__label" htmlFor={id}>
        {label}
      </label>
      {(errorMessage || hint) && (
        <InputFeedback hasError={hasError} errorMessage={errorMessage} hint={hint} />
      )}
    </div>
  )
)

export default Radio
